import type { ButtonHTMLAttributes } from "react";
import { Spinner } from "./feedback";
import { useWritable } from "./writable";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "md" | "sm";
  /** Shows a spinner and blocks further clicks while a request is in flight. */
  busy?: boolean;
  /** This button changes data: it is turned off, with an explanation, while the license makes the installation read-only. */
  write?: boolean;
}

export function Button({ variant = "secondary", size = "md", busy = false, write = false, className, children, disabled, title, type = "button", ...rest }: ButtonProps) {
  const writable = useWritable();
  const blocked = write && writable.readOnly;
  return (
    <button
      type={type}
      className={["cc-button", `cc-button--${variant}`, `cc-button--${size}`, className].filter(Boolean).join(" ")}
      disabled={disabled || busy || blocked}
      aria-busy={busy || undefined}
      title={blocked ? writable.reason : title}
      {...rest}
    >
      {busy ? <Spinner size={16} /> : null}
      {children}
    </button>
  );
}
